import TPEAction from 'src/models/common/TPEAction';
import { DerivedAllocationSheetBuilderState, initialState } from './DerivedAllocationSheetBuilderState';

export const ACTIONS = Object.freeze({
    SET_SHEET_RESULT: new TPEAction('SET_SHEET_RESULT'),
    SET_LOADING: new TPEAction('SET_LOADING'),
    SET_ERROR: new TPEAction('SET_ERROR'),
    SET_VIEW_MODE: new TPEAction('SET_VIEW_MODE'),
    SET_DATA_SOURCES: new TPEAction('SET_DATA_SOURCES'),
    SET_TOTALS: new TPEAction('SET_TOTALS'),
    REFRESH_SHEET: new TPEAction('REFRESH_SHEET'),
    REFRESH_TOTALS: new TPEAction('REFRESH_TOTALS'),
    SET_STEP_UNSAVED: new TPEAction('SET_STEP_UNSAVED'),
});

export function derivedAllocationSheetBuilderReducer(
    state: DerivedAllocationSheetBuilderState = initialState,
    action: TPEAction,
): DerivedAllocationSheetBuilderState {
    switch (action.type) {
        case ACTIONS.SET_SHEET_RESULT.type: {
            const { sheet, availableVersions } = action.payload ?? {};
            return {
                ...state,
                sheet: sheet ?? null,
                availableVersions: availableVersions ?? [],
                loading: false,
                error: undefined,
            };
        }
        case ACTIONS.SET_LOADING.type:
            return { ...state, loading: action.payload };
        case ACTIONS.SET_ERROR.type:
            return { ...state, error: action.payload, loading: false };
        case ACTIONS.SET_VIEW_MODE.type:
            return { ...state, viewMode: action.payload };
        case ACTIONS.SET_DATA_SOURCES.type:
            return { ...state, dataSources: action.payload ?? [] };
        case ACTIONS.SET_TOTALS.type:
            return { ...state, totals: action.payload ?? [] };
        case ACTIONS.REFRESH_SHEET.type:
            return { ...state, sheetRefreshToken: state.sheetRefreshToken + 1 };
        case ACTIONS.REFRESH_TOTALS.type:
            return { ...state, totalsRefreshToken: state.totalsRefreshToken + 1 };
        case ACTIONS.SET_STEP_UNSAVED.type: {
            const { step, unsaved } = action.payload as { step: number, unsaved: boolean };
            const others = state.unsavedSteps.filter((s) => s !== step);
            const unsavedSteps = unsaved ? [...others, step] : others;
            return unsavedSteps.length === state.unsavedSteps.length && unsaved === state.unsavedSteps.includes(step)
                ? state : { ...state, unsavedSteps };
        }
        default:
            return state;
    }
}
